"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function tag(tag) {
    return function tagOperation(source) {
        return source.lift(new TagOperator(tag));
    };
}
exports.tag = tag;
var TagOperator = (function () {
    function TagOperator(tag) {
        this.tag = tag;
    }
    TagOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(subscriber);
    };
    return TagOperator;
}());



// WEBPACK FOOTER //
// /app/node_modules/rxjs-spy/operators/tag.js.pre-build-optimizer.js